import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import SignUpView from 'views/SignUp';
import RegisterService from 'api/Register';
import UserService from 'api/User';
import { useSubmit } from 'hooks';
import { formatDataPhoneToSend } from 'utils';
import SettingsActions from 'store/reducers/Settings';
import useFetch from 'hooks/useFetch';
import { useLocation } from 'react-router-dom'


function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const SignUp = ({ locale, toggleLoading, toggleErrorAlert, switchLanguage, }) => {
  const [dataSubmitted, setDataSubmitted] = useState(false);

  const [data, dataLoading] = useFetch({
    promise: UserService.getCurrency,
    toggleErrorAlert,
    deps: [],
    reInit: true,
  });

  const [price, priceLoading] = useFetch({
    promise: UserService.getSignUpPromo,
    toggleErrorAlert,
    deps: [],
    reInit: true,
  });

  let query = useQuery();
  var params = query.get('language');

  const Language = (lang) => {
    if (lang) {
      locale = lang.toLowerCase();
    } else {
      locale = "en";
    }
    switchLanguage({
      locale: locale == "en" ? "en" : "es",
      name: locale == "en" ? "english" : "spanish",
    });
  };

  if (price) {
    price.fee = locale.locale == "es" ? price.fee.replace(".", ",") : price.fee
  }

  // useEffect(() => {
  //   if (price) {
  //     price.fee = locale.locale == "es" ? price.fee.replace(".", ",") : price.fee
  //   }
  // }, [locale, price])

  useEffect(() => {
    var params = query.get('language');
    try {
      if (params) {
        Language(params);
      }
    } catch (error) { }
  }, []);

  const submitForm = useSubmit({
    promise: (dataToSend) => RegisterService.registerAccount(dataToSend),
    format: (dataToFormat) => {
      const dataToSend = formatDataPhoneToSend(dataToFormat);
      return ({
        ...dataToSend,
        passwordConfirmation: undefined,
        language: locale ? locale.locale : 'en',
      });
    },
    toggleLoading,
    callback: () => setDataSubmitted(true),
  });

  return (
    <SignUpView
      data={!!!dataLoading ? data : {}}
      price={!!!priceLoading ? price : {}}
      dataSubmitted={dataSubmitted}
      onSubmit={submitForm}
    />
  );
};

const mapStateToProps = ({ settings }) => ({ locale: settings.locale });

const mapDispatchToProps = ({
  toggleLoading: SettingsActions.toggleLoading,
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
  switchLanguage: SettingsActions.switchLanguage,

});

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
